import { useTranslation } from "react-i18next";
import { BlogPostDetails } from "@/lib/types";
import { showSuccess, showApiError } from "@/lib/toast";
import { updateBlogPost } from "@/sideEffects/api";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { FormSchemaType, BlogPostMetaForm } from "../form/BlogPostMetaForm";

interface Props {
  blogPost: BlogPostDetails;
}

export const UpdateBlogPost: React.FC<Props> = ({ blogPost }) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const updateBlogPostMutation = useMutation({
    mutationFn: (values: FormSchemaType) => updateBlogPost(blogPost.id, values.title, values.content),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getBlogPostDetails", blogPost.id],
      });
      showSuccess(t("common.updatedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <div className="m-  1">
      <BlogPostMetaForm
        buttonText={t("common.update")}
        onSubmit={(values) => updateBlogPostMutation.mutate(values)}
        isLoading={updateBlogPostMutation.isPending}
        defaultValues={{
          title: blogPost.title,
          content: blogPost.content,
        }}
      />
    </div>
  );
};
